// src/pages/admin/AdminLayout.js
import React from "react";
import { Link, Outlet } from "react-router-dom";

const AdminLayout = () => {
  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Sidebar */}
      <div className="w-64 bg-primary text-white p-6 space-y-4">
        <h2 className="text-2xl font-bold mb-6">Admin Panel</h2>

        <nav className="space-y-3">
          <Link to="/admin/products" className="block hover:bg-violet-600 p-2 rounded">Products</Link>
          <Link to="/admin/categories" className="block hover:bg-violet-600 p-2 rounded">Categories</Link>
          <Link to="/admin/orders" className="block hover:bg-violet-600 p-2 rounded">Orders</Link>
          <Link to="/admin/contactsubmissions" className="block hover:bg-violet-600 p-2 rounded">Contact Submissions</Link>
          <Link to="/admin/managesubscriptions" className="block hover:bg-violet-600 p-2 rounded">Manage Subscriptions</Link>
          <Link to = "/admin/blogs" className="block hover:bg-violet-600 p-2 rounded">Blogs</Link>
          <Link to="/admin/createadmin" className="block hover:bg-violet-600 p-2 rounded">Create Admin</Link>
          <Link to="/admin/adminlist" className="block hover:bg-violet-600 p-2 rounded">Admin List</Link>
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex-1 p-6">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
